export default __webpack_public_path__ + "static/media/G0680.34I-26416_-19046_0.1654023360000.90370dad.jpg";